import defaultsDeep from 'lodash/defaultsDeep';
import type { Options } from './axios-config';
import BaseConfig from './http.base-instance-config';
import { getRegionVariable } from '@white-label-helper/get-region-variable';

const { interceptors } = BaseConfig;
const baseURL = `${getRegionVariable('domains.search')}/v2`;

interface ProductInstance extends Options {
  baseURL: string | undefined;
}

const options: ProductInstance = defaultsDeep({
  baseURL,
},
BaseConfig.options,
);

export default {
  interceptors,
  options,
};
